<template>
  <div class="bg-gray-200 home">

    <Header />

		<!--Container-->
		<div class="container max-w-6xl px-4 mx-auto md:px-0">
      <div class="w-full p-12 leading-normal text-gray-800">
        <div >
          <h1 class="pb-4 text-xl font-bold">Nutzungsvereinbarung</h1>
          <p class="py-2 text-base">Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor, necessitatibus assumenda incidunt neque, quaerat eligendi magnam commodi corrupti optio dolorum magni sint. Voluptas reiciendis perspiciatis ratione facilis ad quasi quaerat!</p>
          <p class="py-2 text-base">Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor, necessitatibus assumenda incidunt neque, quaerat eligendi magnam commodi corrupti optio dolorum magni sint. Voluptas reiciendis perspiciatis ratione facilis ad quasi quaerat!</p>
          <p class="py-2 text-base">Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor, necessitatibus assumenda incidunt neque, quaerat eligendi magnam commodi corrupti optio dolorum magni sint. Voluptas reiciendis perspiciatis ratione facilis ad quasi quaerat!</p>
          <p class="py-2 text-base">Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor, necessitatibus assumenda incidunt neque, quaerat eligendi magnam commodi corrupti optio dolorum magni sint. Voluptas reiciendis perspiciatis ratione facilis ad quasi quaerat!</p>
          <p class="py-2 text-base">Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor, necessitatibus assumenda incidunt neque, quaerat eligendi magnam commodi corrupti optio dolorum magni sint. Voluptas reiciendis perspiciatis ratione facilis ad quasi quaerat!</p>
          <p class="py-2 text-base">Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor, necessitatibus assumenda incidunt neque, quaerat eligendi magnam commodi corrupti optio dolorum magni sint. Voluptas reiciendis perspiciatis ratione facilis ad quasi quaerat!</p>
          <p class="py-2 text-base">Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor, necessitatibus assumenda incidunt neque, quaerat eligendi magnam commodi corrupti optio dolorum magni sint. Voluptas reiciendis perspiciatis ratione facilis ad quasi quaerat!</p>
        </div>
      </div>
    </div>

    <Footer />

  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default {
  name: "UserAgreement",
  components: {
    Header,
    Footer
  },
};
</script>